import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  const initializeGoogleAnalytics = () => {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
      // Initialize GA tracking
      window.gtag('config', 'G-B3RFSCXG73');
    }
  };

  const disableGoogleAnalytics = () => {
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
    // Remove existing GA cookies
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const cookieName = cookie.split('=')[0].trim();
      if (cookieName.startsWith('_ga') || cookieName.startsWith('_gid')) {
        // Remove cookie for current domain
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.mapprints.de`;
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=mapprints.de`;
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
      }
    }
  };

  useEffect(() => {
    const cookiePreference = localStorage.getItem('cookieConsent');
    const analyticsPreference = localStorage.getItem('analyticsConsent');

    setIsVisible(cookiePreference === null);

    // Only initialize GA if consent was previously given
    if (analyticsPreference === 'true') {
      initializeGoogleAnalytics();
    } else if (analyticsPreference === 'false') {
      disableGoogleAnalytics();
    }
  }, []);

  const handleCookieChoice = (accepted, allowAnalytics = false) => {
    localStorage.setItem('cookieConsent', accepted ? 'true' : 'false');
    localStorage.setItem('analyticsConsent', allowAnalytics ? 'true' : 'false');
    setIsVisible(false);

    if (allowAnalytics) {
      initializeGoogleAnalytics();
    } else {
      disableGoogleAnalytics();
    }
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 z-50">
      <div className="container mx-auto max-w-4xl flex flex-col gap-4">
        <div className="text-sm">
          Diese Website verwendet Cookies. Mit der Nutzung unserer Dienste erklären Sie sich damit
          einverstanden, dass wir Cookies verwenden.
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link to="/privacy" className="text-sm underline">
            Details in der Datenschutzerklärung
          </Link>
          <div className="flex gap-4">
            <button
              onClick={() => handleCookieChoice(true, false)}
              className="bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-md text-sm transition-colors"
            >
              Nur notwendige Cookies
            </button>
            <button
              onClick={() => handleCookieChoice(true, true)}
              className="bg-white hover:bg-gray-100 text-gray-900 px-4 py-2 rounded-md text-sm transition-colors"
            >
              Alle akzeptieren
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;